"use strict";

var $ = jQuery.noConflict();

jQuery(document).ready(function ($) {
    // ========================================================================
    // 1. INICJALIZACJA FANCYBOX
    // ========================================================================
    if (typeof Fancybox !== 'undefined') {
        Fancybox.bind("[data-fancybox]", {
            Html5Video: { autoplay: true, controls: true },
            Youtube: { autoplay: 1, nocookie: false },
            Iframe: { preload: false },
            Hash: false,
            l10n: typeof novisaData !== 'undefined' && novisaData.i18n ? novisaData.i18n.fancybox : undefined
        });
    }

    // ========================================================================
    // 2. OBSŁUGA GŁÓWNEGO SLIDERA TŁA
    // ========================================================================
    const $bgSlider = $('.lp-background-slider');
    let bgSwiperInstance = null;

    if ($bgSlider.length) {
        const $prewrap = $bgSlider.closest('.lp-background-slider__prewrap');
        const prevEl = $prewrap.find('[data-js="slider-prev"]')[0];
        const nextEl = $prewrap.find('[data-js="slider-next"]')[0];

        bgSwiperInstance = new Swiper($bgSlider[0], {
            rewind: true, 
            effect: 'fade',
            speed: 1500, 
            fadeEffect: { crossFade: true },
            allowTouchMove: false,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            }
        });

        if (typeof Fancybox !== 'undefined') {
            Fancybox.bind('[data-fancybox="landing-gallery"]', {
                on: {
                    reveal: () => { if (bgSwiperInstance) bgSwiperInstance.autoplay.stop(); },
                    destroy: () => { if (bgSwiperInstance) bgSwiperInstance.autoplay.start(); }
                }
            });
        }
    }

    // ========================================================================
    // 3. MECHANIKA "DRAG TO SCROLL"
    // ========================================================================
    const featuresSlider = document.querySelector('.features-group');
    let isDown = false;
    let startX;
    let scrollLeft;

    if (featuresSlider && window.innerWidth >= 1200) {
        featuresSlider.addEventListener('mousedown', (e) => {
            isDown = true;
            featuresSlider.style.scrollSnapType = 'none'; 
            startX = e.pageX - featuresSlider.offsetLeft;
            scrollLeft = featuresSlider.scrollLeft;
        });
        
        featuresSlider.addEventListener('mouseleave', () => {
            isDown = false;
            featuresSlider.style.scrollSnapType = 'x mandatory';
        });
        
        featuresSlider.addEventListener('mouseup', () => {
            isDown = false;
            featuresSlider.style.scrollSnapType = 'x mandatory';
        });
        
        featuresSlider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - featuresSlider.offsetLeft;
            const walk = (x - startX) * 2; 
            featuresSlider.scrollLeft = scrollLeft - walk;
        });
    }

    // ========================================================================
    // 4. OBSŁUGA ZWIJANIA/ROZWIJANIA TEKSTU RODO
    // ========================================================================
    const noticeText = document.querySelector('.admin-notice__text');
    const noticeToggle = document.querySelector('.admin-notice__toggle');

    if (noticeText && noticeToggle) {
        noticeToggle.addEventListener('click', () => {
            const isExpanded = noticeText.classList.toggle('is-expanded');
            noticeToggle.textContent = isExpanded ? 'zwiń' : 'rozwiń';
        });
    }
});

// ============================================================================
// 5. OBSŁUGA FORMULARZA WPFORMS I YOULEAD
// ============================================================================
jQuery(($) => {
  $(".wpforms-form").change((e) => {
    if (!$(".wpforms-form").hasClass('contact__form--change')) {
      $(".wpforms-form").addClass('contact__form--change');
      $("body").addClass('contact__form--wide');
    }
  });

  // Dynamiczne radio/checkboxy z domami
  $(document).on('change', '.contact__interests__checkbox', function(e) {
    const vals = Array.from($(".contact__interests__checkbox:checked").map((i, b) => $(b).val()));
    $(".yl-description input[type='hidden']").val(vals.join(", "));

    $(e.target).siblings('label').find('input[type="hidden"][data-yl-class]').each((i, el) => {
      if ($(e.target).is(":checked")) {
        $(el).addClass($(el).data('yl-class'));
      } else {
        $(el).removeClass($(el).data('yl-class'));
      }
    });
  });

  // Ukryte zgody z inputów
  $(".yl-name input").change((e) => $(".yl-zgoda_przetwarzanie_OK input[type='hidden']").val($(e.target).val() ? 1 : 0));
  $(".yl-email input").change((e) => $(".yl-zgoda_na_kontakt_e-mail__OK input[type='hidden']").val($(e.target).val() ? 1 : 0));
  $(".yl-telefon input").change((e) => $(".yl-zgoda_na_kontakt_sms_OK input[type='hidden']").val($(e.target).val() ? 1 : 0));

  // Zaznaczanie wszystkich zgód
  $(document).on('change', '.check-all-consents input[type="checkbox"]', function() {
      const isChecked = $(this).is(':checked');
      const $otherConsents = $('.wpforms-field-checkbox:not(.dynamic-acf-interests):not(.check-all-consents) input[type="checkbox"]');
      $otherConsents.prop('checked', isChecked).trigger('change');
  });

  // Odznaczanie "wszystkich"
  $(document).on('change', '.wpforms-field-checkbox:not(.dynamic-acf-interests):not(.check-all-consents) input[type="checkbox"]', function() {
      if (!$(this).is(':checked')) {
          $('.check-all-consents input[type="checkbox"]').prop('checked', false);
      }
  });

  // Wstrzykiwanie "Rozwiń/Zwiń" do zgód
  const consentItems = document.querySelectorAll('.landing-consents li');
  consentItems.forEach(li => {
      const label = li.querySelector('label');
      if (label) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'consent-toggle-btn';
          btn.innerText = 'rozwiń';
          li.appendChild(btn);

          btn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              const isExpanded = label.classList.toggle('is-expanded');
              btn.innerText = isExpanded ? 'zwiń' : 'rozwiń';
          });
      }
  });
});

jQuery(document).on('wpformsAjaxBeforeSubmit', '.wpforms-form', function(e) {
  var $form = jQuery(this);
  
  // Przeniesienie klas YouLead z kontenerów na inputy
  $form.find('[class*="yl-"]').each(function() {
      var $container = jQuery(this);
      if (!$container.is('input, select, textarea')) {
          var classes = $container.attr('class').split(' ');
          var $input = $container.find('input, select, textarea').first();
          
          if ($input.length) {
              classes.forEach(function(cls) {
                  if (cls.startsWith('yl-')) {
                      $input.addClass(cls);
                  }
              });
          }
      }
  });

  // Odbudowa danych domów dla YouLead
  $form.find('.custom-dynamic-hidden-house').remove();
  
  var $investmentField = $form.find('.yl-investment input').first();
  if (!$investmentField.length) $investmentField = $form.find('input.yl-investment');
  var investmentNameText = $investmentField.length ? $investmentField.val() : '';

  $form.find('.contact__interests__checkbox').each(function(index) {
      var $cb = jQuery(this);
      if ($cb.is(':checked')) {
          var ylIdFromAcf = $cb.attr('data-youlead-id') || ''; 
          $form.append('<input type="hidden" class="custom-dynamic-hidden-house yl-dom-' + index + '-investment_id" value="' + ylIdFromAcf + '">');
          if (investmentNameText) {
              $form.append('<input type="hidden" class="custom-dynamic-hidden-house yl-dom-' + index + '-investment_name" value="' + investmentNameText + '">');
          }
      }
  });

  // Odpalenie YouLead API
  if (window.Monitor && typeof Monitor.TrackForm === 'function') {
    try {
        var targetId = $form.attr('id') === 'contactForm' ? 'contactForm' : 'contactForm';
        Monitor.TrackForm(targetId, 3, function (response) {});
    } catch(err) {
        console.error('Błąd skryptu YouLead:', err);
    }
  }
});

// ============================================================================
// 6. GCLID TRACKING
// ============================================================================
(() => {
  const STORAGE_KEY = 'gclid';
  const EXP_MS = 90 * 24 * 60 * 60 * 1000;
  
  // FIX: Selektor usunięto [type="hidden"], łapie teraz również pola ukryte naszą klasą
  const FIELD_SELECTORS = ['.yl-gclid input', '#gclid_field', 'input[name="gclid"]', 'input[data-gclid]'];

  const now = () => Date.now();
  const saveGclid = (value) => {
    const record = { value, expiry: now() + EXP_MS };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    return record;
  };

  const readGclid = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data || typeof data.value !== 'string' || typeof data.expiry !== 'number') return null;
      if (now() > data.expiry) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
  };

  const getParams = () => new URLSearchParams(window.location.search);
  const isGclsrcValid = (gclsrc) => !gclsrc || gclsrc.toLowerCase().includes('aw');
  const findField = () => document.querySelector(FIELD_SELECTORS.join(','));

  const addGclid = () => {
    const params = getParams();
    const gclidParam = params.get('gclid');
    const gclsrcParam = params.get('gclsrc');
    let record = readGclid();

    if (gclidParam && isGclsrcValid(gclsrcParam)) {
      record = saveGclid(gclidParam);
    }

    const field = findField();
    if (field && record) {
      field.value = record.value;
      if ('defaultValue' in field) field.defaultValue = record.value;
    }
  };
  document.addEventListener('DOMContentLoaded', addGclid);
})();